const organization_details = {
    page_title: 'جزئیات سازمان',
    delete_confirmation: 'پس از حذف، همه اعضا عضویت و نقش‌های خود در این سازمان را از دست می‌دهند. این عمل قابل بازگشت نیست.',
    organization_id: 'شناسه سازمان',
    settings_description: 'سازمان‌ها نمایانگر تیم‌ها، مشتریان تجاری و شرکت‌های شریک هستند که می‌توانند به برنامه‌های شما دسترسی داشته باشند.',
    name_placeholder: 'نام سازمان، نیازی به یکتا بودن ندارد.',
    description_placeholder: 'توضیح سازمان.',
    member: 'عضو',
    member_other: 'اعضا',
    add_members_to_organization: 'افزودن اعضا به سازمان {{name}}',
    add_members_to_organization_description: 'کاربران مناسب را با جستجوی نام، ایمیل، تلفن یا شناسه کاربر پیدا کنید. اعضای موجود در نتایج جستجو نمایش داده نمی‌شوند.',
    add_with_organization_role: 'افزودن با نقش(های) سازمان',
    user: 'کاربر',
    application: 'برنامه',
    application_other: 'برنامه‌ها',
    add_applications_to_organization: 'افزودن برنامه‌ها به سازمان {{name}}',
    add_applications_to_organization_description: 'برنامه‌های مناسب را با جستجوی شناسه برنامه، نام یا توضیحات پیدا کنید. برنامه‌های موجود در نتایج جستجو نمایش داده نمی‌شوند.',
    at_least_one_application: 'حداقل یک برنامه لازم است.',
    remove_application_from_organization: 'حذف برنامه از سازمان',
    remove_application_from_organization_description: 'پس از حذف، برنامه ارتباط و نقش‌های خود در این سازمان را از دست می‌دهد. این عمل قابل بازگشت نیست.',
    search_application_placeholder: 'جستجو بر اساس شناسه برنامه، نام یا توضیحات',
    roles: 'نقش‌های سازمان',
    authorize_to_roles: '{{name}} را مجاز کنید به نقش‌های زیر دسترسی داشته باشد:',
    edit_organization_roles: 'ویرایش نقش‌های سازمان',
    edit_organization_roles_title: 'ویرایش نقش‌های سازمان {{name}}',
    remove_user_from_organization: 'حذف کاربر از سازمان',
    remove_user_from_organization_description: 'پس از حذف، کاربر عضویت و نقش‌های خود در این سازمان را از دست می‌دهد. این عمل قابل بازگشت نیست.',
    search_user_placeholder: 'جستجو بر اساس نام، ایمیل، تلفن یا شناسه کاربر',
    at_least_one_user: 'حداقل یک کاربر لازم است.',
    organization_roles_tooltip: 'نقش‌های اختصاص‌یافته به {{type}} در این سازمان.',
    custom_data: 'داده سفارشی',
    custom_data_tip: 'داده سفارشی یک شیء JSON است که می‌تواند برای ذخیره داده‌های اضافی مرتبط با سازمان استفاده شود.',
    invalid_json_object: 'شیء JSON نامعتبر است.',
    branding: {
        name: 'برندسازی',
        description: 'تجربه ورود در سطح سازمان را سفارشی کنید.',
        organization_level_sie: 'تجربه ورود در سطح سازمان',
        organization_level_sie_switch: 'تجربه ورود در سطح سازمان را فعال کنید و برندسازی مختص سازمان را تنظیم کنید. اگر غیرفعال باشد، ابتدا به تجربه ورود در سطح برنامه و سپس به تجربه ورود جامع بازمی‌گردد.',
        logo: 'لوگوهای سازمان',
        logo_tooltip: 'می‌توانید شناسه سازمان را ارسال کنید تا این لوگو در تجربه ورود نمایش داده شود؛ نسخه تاریک لوگو در صورت فعال بودن حالت تاریک در تنظیمات تجربه ورود جامع لازم است. <a>بیشتر بدانید</a>',
    },
    jit: {
        title: 'تأمین لحظه‌ای',
        description: 'کاربران می‌توانند به‌صورت خودکار به سازمان بپیوندند و نقش‌ها را در اولین ورود از طریق برخی روش‌های احراز هویت دریافت کنند. می‌توانید الزامات تأمین لحظه‌ای را تنظیم کنید.',
        email_domain: 'تأمین بر اساس دامنه ایمیل',
        email_domain_description: 'کاربران جدیدی که با آدرس ایمیل تأییدشده ثبت‌نام می‌کنند یا از طریق ورود اجتماعی با ایمیل تأییدشده وارد می‌شوند، به‌صورت خودکار به سازمان می‌پیوندند. <a>بیشتر بدانید</a>',
        email_domain_placeholder: 'دامنه‌های ایمیل را برای تأمین لحظه‌ای وارد کنید',
        invalid_domain: 'دامنه نامعتبر',
        domain_already_added: 'دامنه از قبل اضافه شده است',
        sso_enabled_domain_warning: 'یک یا چند دامنه ایمیل مرتبط با SSO سازمانی وارد کرده‌اید. کاربران با این ایمیل‌ها جریان استاندارد SSO را دنبال می‌کنند و تا زمانی که تأمین SSO سازمانی پیکربندی نشود، به این سازمان تأمین نمی‌شوند.',
        enterprise_sso: 'تأمین SSO سازمانی',
        no_enterprise_connector_set: 'هنوز هیچ اتصال‌دهنده SSO سازمانی راه‌اندازی نکرده‌اید. ابتدا اتصال‌دهنده‌ها را اضافه کنید تا تأمین SSO سازمانی فعال شود. <a>راه‌اندازی</a>',
        add_enterprise_connector: 'افزودن اتصال‌دهنده سازمانی',
        enterprise_sso_description: 'کاربران جدید یا موجود که برای اولین بار از طریق SSO سازمانی وارد می‌شوند، به‌صورت خودکار به سازمان می‌پیوندند. <a>بیشتر بدانید</a>',
        organization_roles: 'نقش‌های پیش‌فرض سازمان',
        organization_roles_description: 'نقش‌ها را هنگام پیوستن کاربران به سازمان از طریق تأمین لحظه‌ای اختصاص دهید.',
    },
    mfa: {
        title: 'احراز هویت چندعاملی (MFA)',
        tip: 'وقتی MFA الزامی است، کاربران بدون MFA پیکربندی‌شده هنگام تلاش برای تبادل توکن سازمان رد می‌شوند. این تنظیم بر احراز هویت کاربر تأثیر نمی‌گذارد.',
        description: 'از کاربران بخواهید احراز هویت چندعاملی را برای دسترسی به این سازمان پیکربندی کنند.',
        no_mfa_warning: 'هیچ روش احراز هویت چندعاملی برای مستأجر شما فعال نیست. کاربران تا زمانی که حداقل یک <a>روش احراز هویت چندعاملی</a> فعال شود، نمی‌توانند به این سازمان دسترسی داشته باشند.',
    },
};
export default Object.freeze(organization_details);
